export const displayNounData = (data,setDisplayNoun,setAnswerNounTranslation) => {
     var length = data.length;
     var random = Math.floor(Math.random() * length);
        
     setDisplayNoun(data[random].noun);
     setAnswerNounTranslation(data[random].translation);          
}

export const displayVerbData = (data,setVerbsAnswerObject,verbsAnswerObject) => {
     var length = data.length;
     var random = Math.floor(Math.random() * length);
     //console.log(data);

     setVerbsAnswerObject({...verbsAnswerObject, 
          verb:data[random].verb,
          infinitive:data[random].pureForm,
          I:data[random].I,
          you:data[random].you,
          he:data[random].he,
          we:data[random].we,
          yall:data[random].yall,
          they:data[random].they
     });
}

export const displayVerbDataPast = (data,setVerbsPastAnswerObject,verbsPastAnswerObject) => {
     var length = data.length;
     var random = Math.floor(Math.random() * length);

     setVerbsPastAnswerObject({...verbsPastAnswerObject, 
          verb:data[random].verb,
          infinitive:data[random].pureForm,
          I:data[random].I,
          you:data[random].you,
          he:data[random].he,
          we:data[random].we,
          yall:data[random].yall,
          they:data[random].they
     });




     // setVerbPurePast(data[random].pureForm);   
     // setDisplayVerbPast(data[random].verb);
     // //setAnswerVerbPastTranslation(data[random].translation); //not used but sometimes breaking when I remove it? 
     // setAnswerVerbIPast(data[random].I);
     // setAnswerVerbYouPast(data[random].you);
     // setAnswerVerbHePast(data[random].he);
     // setAnswerVerbWePast(data[random].we);
     // setAnswerVerbYallPast(data[random].yall);
     // setAnswerVerbTheyPast(data[random].they);     
     // console.log('diplayQuizData PAST: ' + data[random].verb); 
     
}


export const displayPhraseData = (data,setDisplayPhrase,setAnswerPhraseTranslation) => {
     var length = data.length;
     var random = Math.floor(Math.random() * length);

     var phraseGrab = data[random].phrase;
     var phraseGrabTrans = data[random].translation;          
     setDisplayPhrase(phraseGrab);
     setAnswerPhraseTranslation(phraseGrabTrans);          
}



export const getFirebaseData = (chosenData,category,setDatabaseData,setNounDBData,setVerbDBData,setVerbPastDBData,setPhraseDBData,getDocs) => {
     //setIsLoading(true);
     const documents = getDocs(chosenData)
     .then((snapshot)=>{
         var dataGrab = new Array(); //which becomes an object for some reason
         snapshot.docs.forEach((doc)=>{
             dataGrab.push({...doc.data(),id:doc.id})
         })
         const dbDataARRAY = Object.values(dataGrab); // Object.values() converts it to an array()

         setDatabaseData(dbDataARRAY); //don't need the spread operator. Just completely reset the state each time this function is called
         //setIsLoading(false);
         if(category == "nouns"){
          setNounDBData(dbDataARRAY);
         }
         else if(category == "verbs"){
          setVerbDBData(dbDataARRAY);
         }
         else if(category == "verbsPast"){
          setVerbPastDBData(dbDataARRAY);
         }
         else if(category == "phrases"){
          setPhraseDBData(dbDataARRAY);
         }
     })
   }////end getFirebaseData()